import { Popper } from '@material-ui/core';
import styled from 'styled-components';
import { from } from 'styles/mixins';
import { addAlpha } from 'utils/addAlpha';

export const Button = styled.button<{ $unread: boolean }>`
  background: transparent;
  border: none;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.5rem;
  cursor: pointer;
  padding: 0;

  svg {
    width: 1rem;
    height: 1rem;
    color: ${({ theme }) => theme.colors.accent};
  }

  ${from.tabletH`
    width: 2rem;
    height: 2rem;
    border-radius: 0.2rem;
    border: solid 0.05rem ${({ theme }) => theme.colors.greyBlue};
    background-color: ${({ theme }) => theme.colors.white};

    :hover:not(:disabled) {
      box-shadow: 0 0.125rem 0.5rem -0.1875rem ${({ theme }) =>
        addAlpha(theme.colors.black, 0.4)};
      background-color: ${({ theme }) => theme.colors.white};
      border-color: ${({ theme }) => theme.colors.accent};
    }
  `}
`;

export const BellContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NewNotificationsIndicator = styled.div`
  position: absolute;
  width: 0.3331rem;
  height: 0.3331rem;
  right: 0;
  top: 0.125rem;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.colors.error};
`;

export const Container = styled.div`
  cursor: pointer;
  display: inline-flex;
  position: relative;
`;

export const ResponsivePopper = styled(Popper)`
  display: none;

  ${from.tabletH`
    display: block;
  `};
`;

export const ClickAwayContainer = styled.div``;
